
const digest = 'ca6eff8a8735be1f5f2e53dc85bbc5209222927b86c8b47e8af5d2decec2fc65';
const css = `._selectionToolbar_s4l8q_1 {
  display: flex;
  position: absolute;
  transition: none !important; /* Disable popper transitions so toolbar doesn't zip around when changing selection. */

  box-shadow: var(--theme-shadow-shallow);
  background-color: var(--theme-primary-background);
  border: 1px solid var(--theme-light-border);
  border-radius: 4px;
  padding: 2px;

  --theme-editor-button-hovered: var(--aha-gray-200);
  transition: all 0.1s ease-out;
}
._selectionToolbarRight_s4l8q_15 {
  flex-direction: column;
}

.aha-fullscreen ._selectionToolbarRight_s4l8q_15 {
  margin-left: 10px;
}

._selectionToolbarAbove_s4l8q_23 {
  flex-direction: row;
}

._selectionToolbar_s4l8q_1 aha-tooltip {
  --Tooltip__tooltip--font-size: 14px;
}
`;

(function() {
  if (!document.getElementById(digest)) {
    var el = document.createElement('style');
    el.id = digest;
    el.textContent = css;
    document.head.appendChild(el);
  }
})();
    
export default {"selectionToolbar":"_selectionToolbar_s4l8q_1","selectionToolbarRight":"_selectionToolbarRight_s4l8q_15","selectionToolbarAbove":"_selectionToolbarAbove_s4l8q_23"};
export { css, digest };
  